<template>
  <div class="realize_wrap">
    <!-- 顶部大图 -->
    <div
        class="realize_img"
        v-if="hiddenFiveNavOne1"
        :style="{ background: `url(${prodFive1.image}) 0 0 no-repeat`, backgroundSize: 'cover' }"
    >
      <div class="img_tit">{{ prodFive1.title }}</div>
    </div>

    <!-- 全新左右分栏Contact区域：左联系方式 右表单 -->
    <div class="contact-wrap">
      <div class="container">
        <div class="contact-box">
          <!-- 左侧公司信息 -->
          <div class="contact-left">
            <div class="contact-item">
              <div class="icon-circle">
                <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M3 21h18"></path>
                  <path d="M5 21V5l7-3 7 3v16"></path>
                  <path d="M9 21v-4h6v4"></path>
                  <path d="M9 9h6"></path>
                </svg>
              </div>
              <div class="text-group">
                <h4>Company:</h4>
                <p>{{ globalDicts.companyName || '--' }}</p>
              </div>
            </div>
            <div class="contact-item">
              <div class="icon-circle">
                <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"></path>
                  <circle cx="12" cy="10" r="3"></circle>
                </svg>
              </div>
              <div class="text-group">
                <h4>Address:</h4>
                <p class="canOpenLink" @click="openAddress">{{ globalDicts.address || '--' }}</p>
              </div>
            </div>
            <div class="contact-item">
              <div class="icon-circle">
                <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                  <polyline points="22,6 12,13 2,6"></polyline>
                </svg>
              </div>
              <div class="text-group">
                <h4>Email:</h4>
                <p class="canOpenLink" @click="openEmail">{{ globalDicts.email || '--' }}</p>
              </div>
            </div>
            <div class="contact-item">
              <div class="icon-circle">
                <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.347 1.903.65 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.304 1.85.524 2.81.65A2 2 0 0122 16.92z"></path>
                </svg>
              </div>
              <div class="text-group">
                <h4>WhatsApp:</h4>
                <p class="canOpenLink" @click="openWhatsapp">{{ globalDicts.contact || '--' }}</p>
              </div>
            </div>
          </div>

          <!-- 右侧Get a Free Quote表单（加宽卡片内边距，左右留白巨大） -->
          <div class="contact-right">
            <div class="quote-card">
              <div class="quote-header">
                <h3>Get a Free Quote</h3>
                <p>Our representative will contact you soon.</p>
              </div>
              <div class="quote-body">
                <!-- Email 必填 -->
                <div class="form-item">
                  <label>Email <span class="required">*</span></label>
                  <input
                      v-model="quoteForm.email"
                      type="text"
                      placeholder="Please enter your email address"
                      maxlength="100"
                      :class="{ invalid: formErrors.email }"
                      @input="clearError('email')"
                  />
                  <div class="char-count">{{ quoteForm.email.length }}/100</div>
                  <div class="error-tip" v-if="formErrors.email">{{ formErrors.email }}</div>
                </div>
                <!-- Name -->
                <div class="form-item">
                  <label>Name</label>
                  <input
                      v-model="quoteForm.name"
                      type="text"
                      placeholder="Please enter your name"
                      maxlength="100"
                      @input="clearError('name')"
                  />
                  <div class="char-count">{{ quoteForm.name.length }}/100</div>
                </div>
                <!-- Company Name -->
                <div class="form-item">
                  <label>Company Name</label>
                  <input
                      v-model="quoteForm.company"
                      type="text"
                      placeholder="Please enter your company name"
                      maxlength="200"
                  />
                  <div class="char-count">{{ quoteForm.company.length }}/200</div>
                </div>
                <!-- Message 必填 -->
                <div class="form-item">
                  <label>Message <span class="required">*</span></label>
                  <textarea
                      v-model="quoteForm.message"
                      placeholder="Please enter your message"
                      maxlength="1000"
                      :class="{ invalid: formErrors.message }"
                      @input="clearError('message')"
                  ></textarea>
                  <div class="char-count">{{ quoteForm.message.length }}/1000</div>
                  <div class="error-tip" v-if="formErrors.message">{{ formErrors.message }}</div>
                </div>
              </div>
              <div class="quote-footer">
                <button class="submit-btn" @click="submitQuote">Submit</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <CallMe />
  </div>
</template>

<script>
import { leftLikeDict } from '../../api/system'
import { findDictHidden, findMainProp } from '../../utils'
import CallMe from '@/components/callme/index'
import {getProductQuote} from '../../api/system'

export default {
  data() {
    return {
      hiddenFiveNavOne1: true,
      prodFive1: {},
      quoteForm: {
        email: '',
        name: '',
        company: '',
        message: ''
      },
      formErrors: {}
    }
  },
  computed: {
    globalDicts() {
      return this.$store.getters.getDicts;
    },
  },
  methods: {
    async leftLikeDictFunc() {
      const res = await leftLikeDict("contractUs_one1");
      if (res.data) {
        this.hiddenFiveNavOne1 = findDictHidden("contractUs_one1", res.data.data)
        this.prodFive1 = findMainProp(res.data.data, "contractUs_one1")
      }
    },
    clearError(field) {
      if (this.formErrors[field]) {
        this.formErrors[field] = ''
      }
    },
    async submitQuote() {
      this.formErrors = {}
      let valid = true
      if (!this.quoteForm.email.trim()) {
        this.formErrors.email = 'Please enter your Email'
        valid = false
      } else if (!/^[\w\.-]+@[\w\.-]+\.\w+$/.test(this.quoteForm.email)) {
        this.formErrors.email = 'Please enter a valid Email'
        valid = false
      }
      if (!this.quoteForm.message.trim()) {
        this.formErrors.message = 'Please enter your Message'
        valid = false
      }
      if (!valid) return
      const submitData = {...this.quoteForm}
      const jsonStr = JSON.stringify(submitData)
      try {
        await getProductQuote(jsonStr)
        this.$message.success('Submitted successfully')
        this.quoteForm = { email: '', name: '', company: '', message: '' }
      } catch (err) {
        this.$message.error('Submission failed, please try again')
      }
    },
    openWhatsapp() {
      const phone = this.globalDicts['whatsapp']
      // 去除空格、+号以外符号，只保留数字
      const cleanPhone = phone.replace(/\s/g, '').replace(/[^\d+]/g, '')
      if (!cleanPhone) return
      window.open(`https://wa.me/${cleanPhone}`)
    },
    openEmail() {
      const mail = this.globalDicts['email']
      if (!mail) return
      // mailto 协议会自动唤起系统默认邮件客户端
      window.open(`mailto:${mail}`)
    },
    openAddress() {
      const address = this.globalDicts['address']
      if (!address) return;
      // 地址转URL编码，避免空格、特殊符号报错
      const encodeAddr = encodeURIComponent(address);
      // Google地图搜索地址链接
      window.open(`https://www.google.com/maps/search/?api=1&query=${encodeAddr}`);
    }
  },
  components: {
    CallMe,
  },
  mounted() {
    this.leftLikeDictFunc();
  }
}
</script>

<style lang="scss" scoped>
.realize_wrap {
  .realize_img {
    width: 100%;
    height: 600px;
    @media screen and (max-width: 768px) {
      height: 50vw;
    }
    background-size: 100% 100%;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: relative;
    .img_tit {
      font-size: 60px;
      font-weight: bold;
      font-family: 'Roboto_Bold', sans-serif;
      @media screen and (max-width: 768px) {
        font-size: 1.2rem;
      }
    }
  }

  .contact-wrap {
    padding:90px 0;
    font-family: 'Roboto', sans-serif;
    .container {
      width:85%;
      //max-width:1480px;
      margin:0 auto;
    }
    .contact-box {
      display:flex;
      gap:80px;
      /* 左右两块高度自动一致 */
      align-items: stretch;
      @media(max-width:768px){
        flex-direction:column;
        gap:50px;
      }
    }

    .contact-left {
      flex:1;
      /* 内部flex实现内容垂直居中 */
      display:flex;
      flex-direction:column;
      justify-content: center;
      gap:55px; /* 左侧整体每项上下间距加宽 */
      .contact-item {
        display:flex;
        align-items:flex-start;
        gap:22px;
        padding-bottom:50px;
        border-bottom:1px solid #ddd;
        .icon-circle {
          width:80px;
          height:80px;
          border-radius:50%;
          background:#880f53;
          flex-shrink:0;
          display:flex;
          align-items:center;
          justify-content:center;
        }
        .text-group {
          flex:1;
          h4 {
            font-family:'Roboto_Bold',sans-serif;
            font-weight: bold;
            font-size:25px;
            margin:0 0 20px;
            color:#111;
          }
          p {
            font-size:21px;
            margin:0;
            color: #212121;
            line-height:1.6;
          }
        }
      }
    }

    /* 表单左右留白保留、内部内容紧凑缩小间距 */
    .contact-right {
      flex:1;
      .quote-card {
        border:1px solid #eee;
        box-shadow:0 4px 18px rgba(0,0,0,0.09);
        padding:60px 70px; /* 卡片左右留白不动保持宽大 */
        border-radius:10px;
        height:100%;
        box-sizing:border-box;
        .quote-header {
          text-align:center;
          margin-bottom:22px; /* 标题往下间距缩小 */
          h3 {
            font-family:'Roboto_Bold',sans-serif;
            font-size:42px;
            color:#000;
            margin:0 0 12px;
          }
          p {
            font-size:18px;
            color:#666;
            margin:0;
          }
        }
        .quote-body {
          display:flex;
          flex-direction:column;
          gap:18px; /* 表单项间距收小，整体紧凑 */
          .form-item {
            display:flex;
            flex-direction:column;
            gap:9px;
            label {
              font-size:19px;
              color:#222;
            }
            input,textarea {
              padding:13px 16px; /* 输入框内边距略微收窄 */
              border:1px solid #d6d6d6;
              border-radius:6px;
              font-size:17px;
              outline:none;
              &:focus {
                border-color:#880f53;
              }
            }
            textarea {
              min-height:120px; /* 文本框高度缩小更紧凑 */
              resize:vertical;
            }
            .invalid {
              border-color:#f53f3f;
            }
            .char-count {
              font-size:14px;
              color:#999;
              text-align:right;
            }
            .error-tip {
              font-size:14px;
              color:#f53f3f;
            }
          }
        }
        .quote-footer {
          margin-top:30px; /* 按钮上边距收窄 */
          text-align:center;
          .submit-btn {
            background:#880f53;
            color:#fff;
            border:none;
            padding:12px 50px;
            font-size:19px;
            //border-radius:6px;
            cursor:pointer;
            &:hover {
              background:#7a1e52;
            }
          }
        }
      }
    }
  }
}

.required {
  color:#f53f3f;
}

@media(max-width:768px){
  .contact-wrap {
    padding:50px 0!important;
    .contact-left {
      /* 移动端取消垂直居中，正常排布 */
      justify-content: unset;
      gap:35px!important;
      .contact-item {
        gap:16px!important;
        padding-bottom:26px!important;
        .icon-circle {
          width:56px!important;
          height:56px!important;
        }
        .text-group h4 {
          font-size:22px !important;
          font-family:'Roboto_Bold',sans-serif;
        }
        .text-group p {
          font-size:16px!important;
          font-family:'Roboto',sans-serif;
        }
      }
    }
    .contact-right {
      .quote-card {
        padding:50px 38px !important;
      }
      .quote-header h3 {
        font-size:22px !important;
      }
      .quote-header p {
        font-size:12px !important;
        margin-bottom: 20px !important;
      }
      .quote-body {
        gap:10px !important;
        .form-item label {
          font-size:15px !important;
        }
        .form-item input,.form-item textarea {
          font-size:15px !important;
          padding:10px 16px !important;
        }
        .form-item textarea {
          min-height:110px !important;
        }
        .char-count{
          font-size:10px !important;
        }
        .error-tip{
          font-size:12px !important;
        }
      }
      .submit-btn {
        padding:9px 35px !important;
        font-size:15px !important;
      }
    }
  }
}
.contact-left .contact-item .text-group p.canOpenLink {
  cursor: pointer;
  transition: color 0.2s ease;
  text-decoration: none !important;
  display: inline;
  position: relative;

  &::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: -2px;
    width: 0;
    height: 1px;
    background-color: #880f53;
    transition: width 0.2s ease;
  }

  &:hover {
    color: #880f53 !important;
  }
  &:hover::after {
    width: 100%;
  }
}
</style>

<style lang="scss">
@media (max-width: 768px) {
  .el-message .el-message__content {
    font-size: 16px !important;
  }
}
</style>